import type { ChatLogger } from './contexts';
import { ChatLoggerContext } from './contexts';

type Props = {
  children: React.ReactNode;
} & ChatLogger;

export const ChatLoggerProvider = ({ children, ...logger }: Props) => {

  return (
    <ChatLoggerContext.Provider value={logger}>
      {children}
    </ChatLoggerContext.Provider>
  );
};